var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowFatUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 9.375L10 1.875L17.5 9.375H13.75V16.25C13.75 16.4158 13.6842 16.5747 13.5669 16.6919C13.4497 16.8092 13.2908 16.875 13.125 16.875H6.875C6.70924 16.875 6.55027 16.8092 6.43306 16.6919C6.31585 16.5747 6.25 16.4158 6.25 16.25V9.375H2.5Z",
    stroke: "#1A181E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowFatUp);
export default __webpack_public_path__ + "static/media/arrow-fat-up.2c8cf2043b0c9a55cd22454440a59fe9.svg";
export { ForwardRef as ReactComponent };